import React, { useEffect, useRef } from 'react';

import { View } from 'react-native';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { RouteProp, useRoute } from '@react-navigation/native';

import { HEADER_TITLE_ID } from 'config/testID';

import { SCREEN } from 'router/screens';
import { RouteNavigationParams } from 'router/types';

import {
    selectPlayerConfig,
    selectSpotlightVideoVisible,
} from 'store/player/selectors';

import setAccessibilityFocusTo from 'services/accessibility/setAccessibilityFocusTo';

import LocalizedText from 'components/LocalizedText';
import Text from 'components/Text';

import styles from './styles';

function SimpleNavigationHeaderTitle() {
    const route =
        useRoute<
            RouteProp<RouteNavigationParams, keyof RouteNavigationParams>
        >();
    const title = (route as RouteProp<RouteNavigationParams, SCREEN.COLLECTION>)
        ?.params?.title;
    const shouldSetAccessibilityFocus = (
        route as RouteProp<RouteNavigationParams, SCREEN.SETTINGS>
    ).params?.shouldSetAccessibilityFocus;

    const { visible: playerVisible } = useSelector(selectPlayerConfig);
    const spotlightPlayerVisible = useSelector(selectSpotlightVideoVisible);
    const { t } = useTranslation();

    const titleRef = useRef(null);

    const headerTitle = title || null;
    const totalItems = (
        route as RouteProp<RouteNavigationParams, SCREEN.COLLECTION>
    )?.params?.totalItems;
    const appendText =
        typeof totalItems === 'number' ? ` ${totalItems}` : undefined;

    useEffect(() => {
        if (shouldSetAccessibilityFocus) {
            setTimeout(() => {
                setAccessibilityFocusTo(titleRef);
            }, 100);
        }
    }, [shouldSetAccessibilityFocus]);

    if (headerTitle) {
        return (
            <View
                style={styles.root}
                importantForAccessibility={
                    playerVisible || spotlightPlayerVisible
                        ? 'no-hide-descendants'
                        : 'auto'
                }
                accessibilityElementsHidden={
                    playerVisible || spotlightPlayerVisible
                }
                ref={titleRef}
                accessibilityLabel={`${t(headerTitle)}${appendText || ''}`}
                accessible={shouldSetAccessibilityFocus}
            >
                <LocalizedText
                    textKey={headerTitle}
                    numberOfLines={1}
                    style={styles.title}
                    testID={HEADER_TITLE_ID}
                />
                {!!appendText && (
                    <Text style={styles.appendText}>{appendText}</Text>
                )}
            </View>
        );
    }

    return null;
}

export default SimpleNavigationHeaderTitle;
